import {
  FilterType,
  TeamsTeam,
  buildPerformanceInsightsSummaryDatatableFilter,
  usePerformanceInsightsSummaryDatatable,
} from 'generated/resources/datatable.graphql'

import { track, trackingEvents } from 'modules/core/lib/Tracking'
import i18n from 'modules/core/lib/i18n'

const teamsFilter = (
  source: ReturnType<typeof usePerformanceInsightsSummaryDatatable>,
  teams: Pick<TeamsTeam, 'id' | 'name'>[]
) => {
  return buildPerformanceInsightsSummaryDatatableFilter(source, {
    title: i18n.t('performance_process.analytics.datatable.filters.team'),
    path: 'teamId',
    identifier: 'teamIds',
    type: FilterType.Id,
    default: true,
    categories: [
      {
        kind: 'MultipleChoice',
        operation: 'in',
        options: teams.map(({ name, id }) => ({ label: name, value: id })),
      },
    ],
    onUpdateValue(value) {
      track(trackingEvents.performanceAnalytics.insightsSummaryFilterApplied, {
        type: 'teamIds',
        value,
      })
    },
  })
}

export default teamsFilter
